// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__NG7c0","tab":"ProcedureTabs_tab__6d6kl"};